import React, { useState, useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

function DataGrid({
  data = [],
  columns = [],
  rows = 10,
  responsive = true,
  resizableColumns = true,
  rowsPerPageOptions = [10, 25, 50]
}) {
  const [filters, setFilters] = useState({});

  const onFilter = (e) => {
    setFilters(e.filters);
  }

  return (
    <div className="card">
      <DataTable
        value={data}
        paginator
        rows={rows}
        responsive={responsive}
        resizableColumns={resizableColumns}
        sortMode="multiple"
        emptyMessage="No se encontraron resultados"
        className="p-datatable-customers"
        rowsPerPageOptions={rowsPerPageOptions}
        rowHover
        filters={filters}
        onFilter={onFilter}
      >

        {
          columns.map(column => {
            let filterElement = column.filterElement;

            // Compatibilidad para filtros personalizados que esperan {value, filterCallback}
            // Este patrón permite usar lógica de PrimeReact 5+ en la versión 4.x
            if (typeof filterElement === 'function') {
              const filterValue = (filters[column.field] && filters[column.field].value) || '';
              filterElement = filterElement({
                value: filterValue,
                filterCallback: (val) => {
                  const newFilters = { ...filters };
                  newFilters[column.field] = {
                    value: val,
                    matchMode: column.filterMatchMode || 'contains'
                  };
                  setFilters(newFilters);
                }
              });
            }

            return (
              <Column
                key={column.field}
                field={column.field}
                header={column.header}
                sortable={column.sortable}
                filter={column.filter}
                filterElement={filterElement}
                filterPlaceholder={column.filterPlaceholder}
                filterMatchMode={column.filterMatchMode || "contains"}
                body={column.body && ((rowdata) => column.body(rowdata))}
                style={column.style}
              />
            )
          })
        }

      </DataTable>
    </div>
  )
}

export default DataGrid
